import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
